import { H4 } from 'components/headings';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { FC } from 'react';
import { ReactComponent as AdviceWarning } from '../../assets/images/bushfire-warning-levels/bushfire-warning-levels-advice.svg';
import { ReactComponent as AllWarnings } from '../../assets/images/bushfire-warning-levels/bushfire-warning-levels-all.svg';
import { ReactComponent as EmergencyWarning } from '../../assets/images/bushfire-warning-levels/bushfire-warning-levels-emergency-warning.svg';
import { ReactComponent as WatchAndActWarning } from '../../assets/images/bushfire-warning-levels/bushfire-warning-levels-watch-and-act.svg';
import Carousel from '../carousel';
import { Text } from '../ui/text';
import {
  BushfireWarningSlider,
  IconWrapper,
  SlideCentred,
  TitleText,
} from './bushfire-warning-carousel.styles';

const BushfireWarningCarousel: FC = () => {
  return (
    <Carousel numberOfSlides={4}>
      <BushfireWarningSlider>
        <SlideCentred index={0}>
          <AllWarnings style={{ margin: '30px 0 20px 0' }} />

          <H4>Bushfire Warning Levels</H4>
          <Text>
            Bushfire warning levels reflect the risk to life and property, and
            the amount of time until a fire may arrive. You should consider what
            you will do at each warning level as part of your bushfire plan.
            <br />
            <br />
            Stay informed with bushfire alerts and warnings at{' '}
            <a
              href='https://www.emergency.wa.gov.au'
              target='_blank'
              rel='noreferrer'
            >
              emergency.wa.gov.au.
            </a>
          </Text>
        </SlideCentred>

        <SlideCentred index={1}>
          <IconWrapper>
            <AdviceWarning />
          </IconWrapper>

          <TitleText backgroundColor='yellow'>ADVICE</TitleText>
          <H4>Be aware and keep up to date.</H4>
          <Text>
            There is no immediate threat to lives or homes. Be aware and watch
            for signs of a fire.
          </Text>
        </SlideCentred>

        <SlideCentred index={2}>
          <IconWrapper>
            <WatchAndActWarning />
          </IconWrapper>

          <TitleText backgroundColor='orange'>WATCH AND ACT</TitleText>
          <H4>
            There is a possible threat to lives or homes. Take action now to
            protect yourselves and others.
          </H4>
          <Text>
            There is a possible threat to lives or homes. The safest option is
            to leave early. Only stay and defend if you are mentally and
            physically prepared.
          </Text>
        </SlideCentred>

        <SlideCentred index={3}>
          <IconWrapper>
            <EmergencyWarning />
          </IconWrapper>

          <TitleText backgroundColor='redDark' textColor='white'>
            EMERGENCY WARNING
          </TitleText>
          <H4>
            There is a threat to lives and homes. You may be in danger and need
            to take immediate action.
          </H4>
          <Text>
            An out of control fire is approaching fast and there is a threat to
            lives or homes. You must seek shelter or leave now if it is safe to
            do so.
          </Text>
        </SlideCentred>
      </BushfireWarningSlider>
    </Carousel>
  );
};

export default BushfireWarningCarousel;
